/**
 * Password visibility toggle for login and signup forms.
 * Wraps each password input in a container with an eye icon that toggles type between password and text.
 */
function wrapPasswordInputWithToggle(input) {
  if (input.parentElement && input.parentElement.classList.contains('password-toggle-wrapper')) {
    return;
  }

  const parent = input.parentNode;
  const wrapper = document.createElement('div');
  wrapper.className = 'password-toggle-wrapper';
  parent.insertBefore(wrapper, input);
  wrapper.appendChild(input);

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'password-toggle-btn';
  btn.setAttribute('aria-label', 'Toggle password visibility');
  btn.innerHTML = '<i class="fas fa-eye" aria-hidden="true"></i>';
  wrapper.appendChild(btn);

  btn.addEventListener('click', () => {
    const icon = btn.querySelector('i');
    if (input.type === 'password') {
      input.type = 'text';
      icon.classList.remove('fa-eye');
      icon.classList.add('fa-eye-slash');
    } else {
      input.type = 'password';
      icon.classList.remove('fa-eye-slash');
      icon.classList.add('fa-eye');
    }
  });
}

export function initPasswordToggle() {
  const pageSelectors = [
    '.account-login-page',
    '.account-signup-page',
    '.account-profile-form-page',
    '.account-settings-page',
    '.account-password-change-page',
    '.account-password-reset-confirm-page',
  ];

  const forms = pageSelectors
    .map((selector) => document.querySelector(`${selector} form`))
    .filter(Boolean);

  forms.forEach((form) => {
    const inputs = form.querySelectorAll('input[type="password"]');
    inputs.forEach(wrapPasswordInputWithToggle);
  });
}
